import {EsquireClient} from "@/types/clients/esquire";

export default class GetAvailability {
  constructor(private client: EsquireClient) {}

  public async send(reservationId: string, contractIds: Array<string>): Promise<Array<string>> {
    const url = await this.client.fetchUrlFromSession("availability");
    const data = {
      reservation_id: reservationId,
      contract_ids: contractIds
    };
    const response = await this.client.fetch(
      () => new URL(url), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      }
    );

    if (!response.ok) {
      await this.client.logOutIfForbidden(response.status);
      return [""];
    }
    return await response.json() as Array<string>;
  }
}
